(function () {
  'use strict';

  function updateCartCountUI(itemCount) {
    const count = Number.isFinite(Number(itemCount)) ? Number(itemCount) : 0;

    document.querySelectorAll('.header__cart-count').forEach(function (element) {
      element.textContent = String(count);
    });

    document.querySelectorAll('.tvg_react_cart_icon_C_zLTW_count').forEach(function (element) {
      element.textContent = String(count);
    });
  }

  function emitCartSyncEvents(cart) {
    const detailPayload = {
      cart: cart,
      data: {
        cart: cart,
        item_count: Number(cart?.item_count || 0),
        didError: false,
        source: 'new-product-grid',
      },
    };

    document.dispatchEvent(new CustomEvent('cart:added', {
      bubbles: true,
      detail: detailPayload,
    }));

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: detailPayload,
    }));

    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: detailPayload,
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:add', {
      bubbles: true,
      detail: {
        cart: cart,
      },
    }));
  }

  /* ------------------------------------------------------------------ */
  /* Drag vs click                                                      */
  /* Swiper sets `allowClick = false` on the FIRST pointermove of a      */
  /* press (`threshold` only gates the visual translate, not that flag)  */
  /* and its onClick then runs preventDefault + stopImmediatePropagation */
  /* — so a mouse click that drifted a single pixel never opened the     */
  /* PDP. `preventClicks` off hands the click back; this guard is what   */
  /* cancels it after a real drag, so dragging the carousel still works  */
  /* with the mouse and never lands on a product.                        */
  /* ------------------------------------------------------------------ */

  // Also used as Swiper's `threshold` so the carousel doesn't creep below it.
  const DRAG_SLOP = 10;

  function initDragClickGuard(container) {
    if (container.__dragClickGuard) return;
    container.__dragClickGuard = true;

    let startX = 0;
    let startY = 0;
    let pressed = false;
    let dragged = false;

    container.addEventListener('pointerdown', function (e) {
      pressed = true;
      dragged = false;
      startX = e.clientX;
      startY = e.clientY;
    }, true);

    container.addEventListener('pointermove', function (e) {
      if (!pressed || dragged) return;
      if (Math.abs(e.clientX - startX) > DRAG_SLOP || Math.abs(e.clientY - startY) > DRAG_SLOP) {
        dragged = true;
      }
    }, true);

    ['pointerup', 'pointercancel'].forEach(function (type) {
      container.addEventListener(type, function () { pressed = false; }, true);
    });

    // Capture, so the card's <a> and the delegated ATC/shade handlers never
    // see the click of a drag.
    container.addEventListener('click', function (e) {
      if (!dragged) return;
      dragged = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  /* ------------------------------------------------------------------ */
  /* Section carousel (Swiper)                                          */
  /* Desktop: N slides (Theme Editor setting). Mobile: 1 full slide +   */
  /* a peek of the next one so it reads as a slider.                    */
  /* ------------------------------------------------------------------ */

  function initGridCarousel() {
    const containers = document.querySelectorAll('.js-new-product-grid-swiper');
    if (!containers.length) return;

    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not loaded');
      return;
    }

    containers.forEach(function (container) {
      // Re-init safely (Theme Editor section reloads). loopDestroy first so
      // clone slides never survive into the next init.
      if (container.__gridSwiper) {
        try { container.__gridSwiper.loopDestroy(); } catch (e) { /* noop */ }
        container.__gridSwiper.destroy(true, true);
        container.__gridSwiper = null;
      }

      initDragClickGuard(container);

      const slidesDesktop = parseInt(container.getAttribute('data-slides-desktop'), 10) || 3;
      const carousel = container.closest('.new_product_grid__carousel');
      const prevButton = carousel ? carousel.querySelector('.js-new-product-grid-prev') : null;
      const nextButton = carousel ? carousel.querySelector('.js-new-product-grid-next') : null;

      const config = {
        slidesPerView: 1.15,
        spaceBetween: 16,
        slidesPerGroup: 1,
        // Infinite, same as the theme's video slider (slider-video.js).
        loop: true,
        speed: 400,
        threshold: DRAG_SLOP,
        preventClicks: false,
        preventClicksPropagation: false,
        breakpoints: {
          769: {
            slidesPerView: slidesDesktop,
            spaceBetween: 32,
          },
        },
      };

      // Arrows can be disabled in the Theme Editor. Only add the key when the
      // buttons exist: an explicit `navigation: undefined` overrides Swiper's
      // module defaults and crashes its init.
      if (prevButton && nextButton) {
        config.navigation = { prevEl: prevButton, nextEl: nextButton };
      }

      container.__gridSwiper = new Swiper(container, config);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Per-card image galleries (mobile-only, inside the main carousel)   */
  /* Keyed by [data-card-gallery] so they also init inside loop         */
  /* duplicates and freshly swapped shade-card content. The init guard  */
  /* is an element property — unlike a data-attribute it does NOT get   */
  /* copied by Swiper's loop cloneNode, so duplicates init their own.   */
  /* ------------------------------------------------------------------ */

  function initCardGalleries(root) {
    if (typeof Swiper === 'undefined') return;

    (root || document).querySelectorAll('[data-card-gallery]').forEach(function (gallery) {
      if (gallery.__gallerySwiper) return;

      const prevButton = gallery.querySelector('[data-card-gallery-prev]');
      const nextButton = gallery.querySelector('[data-card-gallery-next]');

      [prevButton, nextButton].forEach(function (btn) {
        if (!btn) return;
        // The gallery lives inside the card's <a> — never navigate.
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      });

      const config = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        // Don't let inner swipes drag the section carousel.
        nested: true,
        // Same as the section carousel — this gallery sits inside the card's
        // <a>, and the guard on the container covers its clicks too.
        threshold: DRAG_SLOP,
        preventClicks: false,
        preventClicksPropagation: false,
        breakpoints: {
          769: {
            enabled: false,
          }
        }
      };

      if (prevButton && nextButton) {
        config.navigation = { nextEl: nextButton, prevEl: prevButton };
      }

      gallery.__gallerySwiper = new Swiper(gallery, config);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Legacy per-card mobile galleries                                   */
  /* The homepage grid cards no longer have one (static image), but     */
  /* collection-style cards (.product_card[data-product-id] with a      */
  /* .js-product-swiper-* container) may share a page with this section */
  /* and still rely on this init.                                       */
  /* ------------------------------------------------------------------ */

  function initLegacyCardGalleries() {
    const productCards = document.querySelectorAll('.product_card[data-product-id]');

    if (!productCards.length) return;

    productCards.forEach(function (card) {
      const productId = card.getAttribute('data-product-id');
      if (!productId) return;

      const swiperContainer = card.querySelector('.js-product-swiper-' + productId);
      if (!swiperContainer) return;

      const prevButton = card.querySelector('.js-product-swiper-button-prev-' + productId);
      const nextButton = card.querySelector('.js-product-swiper-button-next-' + productId);

      if (prevButton) {
        prevButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }

      if (typeof Swiper === 'undefined') {
        console.error('Swiper library not loaded');
        return;
      }

      new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          769: {
            enabled: false,
          }
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Shade cards                                                        */
  /* Each shade is a separate product (shade_group metaobject). Every   */
  /* member's card is server-rendered into a <template>; picking a      */
  /* shade clones it into the visible card — image, title, price, link  */
  /* and ATC variant id all update, like the PDP shade selector.        */
  /* All listeners are delegated so they survive the innerHTML swaps.   */
  /* ------------------------------------------------------------------ */

  const SHADE_DROPDOWN_OPEN_CLASS = 'shade-selector__dropdown--open';
  let shadeListenersAttached = false;

  // The dropdown list can't render in place: the carousel container clips it
  // (overflow: hidden), and position:fixed is no escape because the Swiper
  // wrapper's translate3d makes fixed behave like absolute. So while open,
  // the list is PORTALED to <body> (outside the transformed/clipped subtree)
  // and moved back into its dropdown on close.
  let portaledDropdown = null; // the [data-grid-shade-dropdown] that owns the ported list
  let portaledList = null;
  let portaledCard = null;     // the [data-shade-card] the ported list belongs to

  function closeGridShadeDropdowns() {
    if (portaledDropdown && portaledList) {
      portaledList.removeAttribute('style');
      portaledDropdown.appendChild(portaledList);
    }
    portaledDropdown = null;
    portaledList = null;
    portaledCard = null;

    document.querySelectorAll('[data-grid-shade-dropdown].' + SHADE_DROPDOWN_OPEN_CLASS).forEach(function (dropdown) {
      dropdown.classList.remove(SHADE_DROPDOWN_OPEN_CLASS);
      const trigger = dropdown.querySelector('[data-grid-shade-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openGridShadeDropdown(dropdown, trigger) {
    const list = dropdown.querySelector('.shade-selector__dropdown-list');
    if (!list) return;

    dropdown.classList.add(SHADE_DROPDOWN_OPEN_CLASS);
    trigger.setAttribute('aria-expanded', 'true');

    portaledDropdown = dropdown;
    portaledList = list;
    portaledCard = dropdown.closest('[data-shade-card]');

    const rect = trigger.getBoundingClientRect();

    document.body.appendChild(list);
    // The CSS shows the list via `.--open .__dropdown-list`; outside the
    // dropdown that selector no longer matches, so show it inline.
    list.style.display = 'block';
    list.style.position = 'fixed';
    list.style.zIndex = '1000';

    const listWidth = list.offsetWidth;
    const listHeight = list.offsetHeight;
    const left = Math.max(8, Math.min(rect.left, window.innerWidth - listWidth - 8));

    // Open upwards when there's no room below the trigger.
    let top = rect.bottom + 4;
    if (top + listHeight > window.innerHeight - 8) {
      top = Math.max(8, rect.top - listHeight - 4);
    }

    list.style.top = top + 'px';
    list.style.left = left + 'px';
  }

  function swapShadeCard(card, handle, fallbackUrl) {
    const esc = (window.CSS && CSS.escape) ? CSS.escape.bind(CSS) : function (s) { return s; };
    const template = card.querySelector('[data-shade-card-template="' + esc(handle) + '"]');

    if (!template) {
      // No pre-rendered card for this shade — plain navigation always works.
      if (fallbackUrl) window.location.assign(fallbackUrl);
      return;
    }

    // With loop mode the card exists multiple times (canonical + Swiper's
    // clone slides) — swap every copy, same pattern as slider-video.js.
    const swiperContainer = card.closest('.js-new-product-grid-swiper');
    const cardKey = card.getAttribute('data-shade-card');
    let copies = [card];
    if (swiperContainer && cardKey) {
      copies = swiperContainer.querySelectorAll('[data-shade-card="' + esc(cardKey) + '"]');
    }

    copies.forEach(function (copy) {
      const content = copy.querySelector('[data-shade-card-content]');
      if (!content) return;
      content.innerHTML = '';
      content.appendChild(template.content.cloneNode(true));
      copy.setAttribute('data-current-handle', handle);
    });

    // The swapped content ships a fresh (uninitialized) mobile gallery.
    initCardGalleries(swiperContainer || undefined);

    // Card height may change (title/description length) — resync Swiper.
    if (swiperContainer && swiperContainer.__gridSwiper) {
      swiperContainer.__gridSwiper.update();
    }
  }

  function initShadeCards() {
    if (shadeListenersAttached) return;
    shadeListenersAttached = true;

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-grid-shade-dropdown-trigger]');
      if (trigger) {
        // The selector lives inside the card's <a> — never navigate.
        e.preventDefault();
        e.stopPropagation();
        const dropdown = trigger.closest('[data-grid-shade-dropdown]');
        const isOpen = dropdown && dropdown.classList.contains(SHADE_DROPDOWN_OPEN_CLASS);
        closeGridShadeDropdowns();
        if (dropdown && !isOpen) {
          openGridShadeDropdown(dropdown, trigger);
        }
        return;
      }

      const option = e.target.closest('[data-grid-shade-swatch], [data-grid-shade-option]');
      if (option) {
        e.preventDefault();
        e.stopPropagation();

        // Dropdown options may sit in the body-portaled list, outside the
        // card's DOM — fall back to the card the portal was opened for.
        const card = option.closest('[data-shade-card]') || portaledCard;
        closeGridShadeDropdowns();

        const handle = option.getAttribute('data-shade-handle');
        if (!card || !handle) return;
        if (handle === card.getAttribute('data-current-handle')) return;

        swapShadeCard(card, handle, option.getAttribute('data-shade-url'));
        return;
      }

      if (e.target.closest('[data-grid-shade-root]')) {
        e.preventDefault();
        if (!e.target.closest('[data-grid-shade-dropdown]')) closeGridShadeDropdowns();
        return;
      }

      closeGridShadeDropdowns();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeGridShadeDropdowns();
    });

    // A fixed-positioned list doesn't follow its trigger — just close it.
    window.addEventListener('scroll', closeGridShadeDropdowns, { passive: true });
    window.addEventListener('resize', closeGridShadeDropdowns);
  }

  // Store flag to prevent multiple listeners
  let addToCartListenerAttached = false;

  // The loading state is a class plus an out-of-flow spinner, never an
  // innerHTML swap. Replacing the label with the spinner changed the button's
  // content box (a 16.8px line box became an 18px spinner) and the button grew
  // mid-click — ~1.2px on desktop, ~3.6px on mobile. Keeping the label in place
  // and painting the spinner over it holds the height identical before, during
  // and after the click.
  const LOADING_CLASS = 'is-adding-to-cart';

  function setAddToCartLoading(btn, isLoading) {
    btn.classList.toggle(LOADING_CLASS, isLoading);
    btn.disabled = isLoading;

    if (isLoading) {
      btn.setAttribute('aria-busy', 'true');
      if (!btn.querySelector('.spinner-loader')) {
        btn.insertAdjacentHTML('beforeend', '<span class="spinner-loader"></span>');
      }
      return;
    }

    btn.removeAttribute('aria-busy');
    const spinner = btn.querySelector('.spinner-loader');
    if (spinner) spinner.remove();
  }

  /* ------------------------------------------------------------------ */
  /* Add to cart                                                        */
  /* One delegated listener for every `.js-ajax-add-to-cart` on the     */
  /* page (this carousel + the storytelling grid).                      */
  /*                                                                    */
  /* Marker EB-140 ("extremely slow ATC"): the old flow kept the        */
  /* spinner up until /cart/add.js AND its own /cart.js had answered,   */
  /* opened the drawer 300ms after that, and then broadcast cart:add +  */
  /* cart:added + cart:update + cart:updated. Every listener (drawer,   */
  /* cart-upsell, promo-price-override, bundle-watcher, TVG cart icon)  */
  /* re-fetched /cart.js on each of them — 18–27 /cart.js per click —   */
  /* so they queued behind each other and the button spun for 1.6–2.7s  */
  /* with the drawer still closed.                                      */
  /*                                                                    */
  /* Now the add request is handed to the custom drawer                 */
  /* (handleExternalAdd). The add asks Shopify to render the drawer     */
  /* section in the same response (bundled section rendering), so when  */
  /* it settles the drawer opens already showing the new item; GWP      */
  /* enforcement then runs once on a live /cart.js. The drawer emits    */
  /* cart:updated itself, so nothing else is dispatched here, and the   */
  /* spinner clears as soon as /cart/add.js answers.                    */
  /* ------------------------------------------------------------------ */

  function getCustomCartDrawer() {
    const drawer = document.querySelector('cart-drawer-custom');
    return drawer && typeof drawer.handleExternalAdd === 'function' ? drawer : null;
  }

  // Pages without cart-drawer-custom (or before its script ran): the old
  // bridge — legacy cart:add event, the hidden offcanvas trigger, and a manual
  // /cart.js sync for the header count.
  function completeAddWithoutDrawer(addData) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:add', {
      bubbles: true,
      detail: { cart: addData },
    }));

    const hiddenTrigger = document.querySelector('.js-open-cart-drawer-trigger');
    if (hiddenTrigger) hiddenTrigger.click();

    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' },
    })
      .then(response => (response.ok ? response.json() : null))
      .then(cart => {
        if (!cart) return;
        updateCartCountUI(cart.item_count || 0);
        emitCartSyncEvents(cart);
      })
      .catch(() => null);
  }

  function initAddToCart() {
    if (addToCartListenerAttached) return;
    addToCartListenerAttached = true;

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.js-ajax-add-to-cart');
      if (!btn) return;

      // The button sits inside the card's <a> — never navigate.
      e.preventDefault();

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId || btn.disabled) return;

      setAddToCartLoading(btn, true);

      const drawer = getCustomCartDrawer();
      const payload = { items: [{ id: variantId, quantity: 1 }] };

      // Bundled section rendering: Shopify renders the drawer section inside
      // the add response, so the drawer opens already showing the new item
      // instead of fetching its markup afterwards. bundle-watcher.js forwards
      // these params when it turns this add into a bundle swap.
      const drawerSectionId = drawer && typeof drawer.getSectionRenderingId === 'function'
        ? drawer.getSectionRenderingId()
        : '';
      if (drawerSectionId) {
        payload.sections = drawerSectionId;
        payload.sections_url = window.location.pathname;
      }

      const addRequest = fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).then(response => {
        if (!response.ok) {
          throw new Error('Failed to add product from collection/grid (HTTP ' + response.status + ')');
        }
        return response.json();
      });

      if (drawer) {
        // Shares the same promise; the drawer handles its own errors and opens
        // once the product is actually in the cart.
        drawer.handleExternalAdd(addRequest);
      }

      addRequest
        .then(addData => {
          setAddToCartLoading(btn, false);
          return drawer ? null : completeAddWithoutDrawer(addData);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('[new-product-grid] add-to-cart failed:', error);
          setAddToCartLoading(btn, false);
        });
    });
  }

  function initAll() {
    // Order matters: the main carousel creates its loop clones first, so
    // initCardGalleries also reaches the galleries inside the duplicates.
    initGridCarousel();
    initCardGalleries();
    initLegacyCardGalleries();
    initShadeCards();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();
